// ─── RSVP: Luxe Card ──────────────────────────────────────────
// Dark bordered card with luxe shadow.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';
import RSVPForm from '../../RSVPTemplates/RSVPForm';
import PreviewModeNotice from './PreviewModeNotice';
import RsvpSurfaceShell from './RsvpSurfaceShell';

export default function RsvpLuxeCard({ section, data, theme, settings, rsvpRef }) {
  const anim = section.animation || {};
  const cs = data.customStyle || {};
  const bg = data.background;
  const motionPreset = settings?.motionPreset || 'none';
  const disableAnim = motionPreset !== 'none';

  const accentColor = cs.accentColor || theme.accent;
  const titleColor = cs.textColor || theme.textPrimary;
  const descColor = cs.textColor ? `${cs.textColor}99` : theme.textSecondary;
  const eyebrowColor = cs.accentColor || theme.accent;
  const headingFont = cs.fontFamily || theme.headingFont;

  return (
    <AnimatedSection preset={anim.section || 'fade-in'} disableAnimation={disableAnim}>
      <RsvpSurfaceShell
        cs={cs}
        background={bg}
        naturalMaxWidthRem={42}
        borderRadiusRem={2}
        contentPaddingClass="p-8 sm:p-10"
        sectionPaddingClass="px-6 py-20 sm:py-24"
        surfaceBgColor={cs.bgColor || theme.surface}
        surfaceBorderColor={theme.border}
        legacyShadowClass="shadow-[0_20px_60px_rgba(0,0,0,0.18)]"
        withLegacyBorder
        rsvpRef={rsvpRef}
      >
        <PreviewModeNotice visible={!!settings?.disableRsvpSubmit} />
        <div className="text-center">
          <p
            className="text-[11px] uppercase tracking-[0.2em] mb-3"
            style={{ color: eyebrowColor, fontFamily: theme.eyebrowFont }}
          >
            Response
          </p>
          <h2
            className="text-3xl sm:text-4xl"
            style={{ fontFamily: headingFont, color: titleColor }}
          >
            {data.title || 'RSVP'}
          </h2>
          <p className="mx-auto mt-5 max-w-lg leading-7" style={{ color: descColor }}>
            {data.description || 'Kindly let us know if you can attend'}
          </p>
        </div>
        <div className="mt-10">
          <RSVPForm
            slug={settings.slug}
            accentColor={accentColor}
            labels={data.labels}
            buttonShadowStrength={cs.buttonShadowStrength}
            customStyle={cs}
            disableSubmit={settings?.disableRsvpSubmit}
          />
        </div>
      </RsvpSurfaceShell>
    </AnimatedSection>
  );
}
